module.exports = __webpack_public_path__ + "static/logo-2bf0bd6779693e30b778901242740ea3.svg";